// src/components/Footer/Footer.js
import React from 'react';
import './Footer.css';

const Footer = () => {
  // Navigation items for Frame 99 with corresponding section IDs
  const navItems = [
    { id: 'frame-95', text: '生活保護とは', sectionId: 'infoSection' },
    { id: 'frame-97', text: '選ばれる理由', sectionId: 'reasonsSection' },
    /* { id: 'frame-98', text: '物件情報', sectionId: 'propertyList' }, */
    { id: 'frame-100', text: 'サポートの流れ', sectionId: 'supportFlow' },
    { id: 'frame-101', text: 'よくある質問', sectionId: 'faqSection' },
    { id: 'frame-102', text: 'ブログ', sectionId: 'blogSection' }
  ];

  // Bottom links for Frame 4
  const bottomLinks = [
    { id: 'link-1', text: '利用規約' },
    { id: 'link-2', text: 'プライバシーポリシー', href: '/?page=privacy' },
    { id: 'link-3', text: '外部送信規律に関する公表事項' },
    { id: 'link-4', text: '特定商取引法に基づく表記' },
    { id: 'link-5', text: 'お問い合わせ' },
    { id: 'link-6', text: '運営会社' }
  ];

  // Handle smooth scroll to section
  const scrollToSection = (sectionId) => {
    // First check if we're on the privacy policy page
    const url = new URL(window.location.href);
    if (url.searchParams.get('page') === 'privacy') {
      // First go back to the home page
      window.history.pushState({}, '', '/');
      // Trigger a popstate event to update App.js state
      window.dispatchEvent(new Event('popstate'));
      
      // Need a short delay to ensure the main page content is rendered
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          // Calculate header height for offset
          const headerHeight = document.querySelector('.header-nav-container')?.offsetHeight || 0;
          
          // Scroll to section with offset for header
          window.scrollTo({
            top: section.offsetTop - headerHeight,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      // We're already on the home page, just scroll to the section
      const section = document.getElementById(sectionId);
      if (section) {
        // Calculate header height for offset
        const headerHeight = document.querySelector('.header-nav-container')?.offsetHeight || 0;
        
        // Scroll to section with offset for header
        window.scrollTo({
          top: section.offsetTop - headerHeight,
          behavior: 'smooth'
        });
      }
    }
  };

  // Handle bottom link click
  const handleBottomLinkClick = (link) => {
    if (link.href) {
      // Use history.pushState to update the URL without reloading the page
      window.history.pushState({}, '', link.href);
      // Dispatch a popstate event to trigger the App.js useEffect
      window.dispatchEvent(new Event('popstate'));
      // Scroll to top
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="footer-container">
      {/* Frame 48098560 - Company logo and name */}
      <div className="footer-frame footer-frame-48098560">
        <div className="footer-logo-container">
          <img src={process.env.PUBLIC_URL + '/images/hogoland_logo_dark.png'} alt="ほごらんど Logo" className="footer-logo" />
        </div>
        <div className="footer-company-name">ほごらんど株式会社</div>
      </div>

      {/* Frame 99 - Navigation items */}
      <div className="footer-frame footer-frame-99">
        <div className="footer-nav-items">
          {navItems.map(item => (
            <div 
              key={item.id} 
              className="footer-nav-item" 
              id={item.id}
              onClick={() => scrollToSection(item.sectionId)}
            >
              <span className="footer-nav-text">{item.text}</span>
              {/* Arrow icon for mobile view */}
              <div className="footer-nav-arrow">
                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="16" viewBox="0 0 7 16" fill="none">
                  <path d="M1.69922 1.85449L5.99948 7.87486" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M1.69922 14.1455L5.99948 8.12514" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Line 33 - Horizontal separator */}
      <div className="footer-line-33"></div>

      {/* Frame 4 - Bottom links */}
      <div className="footer-frame footer-frame-4">
        <div className="footer-bottom-links">
          {bottomLinks.map(link => (
            <div 
              key={link.id} 
              className="footer-bottom-link" 
              id={link.id}
              onClick={() => handleBottomLinkClick(link)}
              style={link.href ? { cursor: 'pointer' } : {}}
            >
              <span className="footer-bottom-link-text">{link.text}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Copyright text */}
      <div className="footer-copyright">
        ©2025 Hogoland. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;